"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BC_COACH_MARK_START_POSITION = exports.BC_COACH_MARK_END_POSITION = exports.BC_COACH_MARK_ARROW_SPACE = exports.BC_COACH_MARK_ARROW_CLASS = exports.BC_COACH_MARK_STATUS_ID = exports.BC_COACH_MARK_STATUS_ACTIVE = exports.BC_COACH_MARK_STATUS = exports.BC_COACH_MARK_CLOSE_TEXT = exports.BC_COACH_MARK_PREV_TEXT = exports.BC_COACH_MARK_NEXT_TEXT = exports.BC_COACH_MARK_UNDERSTOOD_TEXT = exports.BC_COACH_MARK_NUMBER_MIN_WIDTH = exports.BC_COACH_MARK_NUMBER_16 = exports.BC_COACH_MARK_NUMBER_20 = exports.BC_COACH_MARK_NUMBER_6 = exports.BC_COACH_MARK_NUMBER_2 = exports.BC_COACH_MARK_NUMBER_1 = exports.BC_COACH_MARK_NUMBER_0 = exports.BC_COACH_MARK_ARIA_LABEL = exports.BC_COACH_MARK_BOTTOM = exports.BC_COACH_MARK_TOP = exports.BC_COACH_MARK_LEFT = exports.BC_COACH_MARK_RIGHT = exports.BC_COACH_MARK_ANIMATION_OUT = exports.BC_COACH_MARK_ANIMATION_IN = exports.BC_COACH_MARK_BLOCK_SCROLL = exports.BC_COACH_MARK_LINK = exports.BC_COACH_MARK_DATA_CONTROLLER = exports.BC_COACH_MARK_DATA_ATTRIBUTE = exports.BC_COACH_MARK_NUMBER = exports.BC_COACH_MARK_QUANTITY_ITEMS = exports.BC_COACH_MARK_ICON = exports.BC_COACH_MARK_CLOSE = exports.COACH_MARK_STEP = exports.COACH_MARK_PREV = exports.COACH_MARK_NEXT = exports.BC_COACH_MARK_PREV = exports.BC_COACH_MARK_NEXT = exports.BC_COACH_MARK_MAIN = exports.BC_COACH_MARK_OVERLAY = exports.BC_COACH_MARK_TARGET = exports.BC_COACH_MARK_HIGHLIGHT = exports.BC_COACH_MARK_FOOTER_FIRST_BUTTON = exports.BC_COACH_MARK_EXPANDED = exports.BC_COACH_MARK_TITLE_ARIA_TITLE = exports.BC_COACH_MARK_TITLE_ARIA = exports.BC_COACH_MARK_TITLE = exports.BC_COACH_MARK_FOOTER = exports.BC_COACH_MARK_CONTAINER = exports.BC_COACH_MARK_SELECTOR = void 0;
exports.bcDisplay = exports.CoachmarkStyle = exports.BC_COACH_BUTTON_FOOTER = exports.BC_COACH_MARK_Z_INDEX = exports.BC_COACH_MARK_Y = exports.BC_COACH_MARK_X = exports.BC_COACH_MARK_POSITION = exports.BC_COACH_MARK_HEIGHT = exports.BC_COACH_MARK_WIDTH = exports.BC_COACH_MARK_CENTER_POSITION = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.BC_COACH_MARK_SELECTOR = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-coach-mark");
exports.BC_COACH_MARK_CONTAINER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-coach-mark-container");
exports.BC_COACH_MARK_FOOTER = "".concat(exports.BC_COACH_MARK_SELECTOR, "-footer");
exports.BC_COACH_MARK_TITLE = "".concat(exports.BC_COACH_MARK_SELECTOR, "-title");
exports.BC_COACH_MARK_TITLE_ARIA = 'Cuadro de diálogo informativo señalando ';
exports.BC_COACH_MARK_TITLE_ARIA_TITLE = ' ,Título';
exports.BC_COACH_MARK_EXPANDED = "".concat(exports.BC_COACH_MARK_SELECTOR, "-expanded");
exports.BC_COACH_MARK_FOOTER_FIRST_BUTTON = "".concat(exports.BC_COACH_MARK_FOOTER, ">button:first-child");
exports.BC_COACH_MARK_HIGHLIGHT = "".concat(exports.BC_COACH_MARK_SELECTOR, "-highlight");
exports.BC_COACH_MARK_TARGET = "".concat(exports.BC_COACH_MARK_SELECTOR, "-target");
exports.BC_COACH_MARK_OVERLAY = "".concat(exports.BC_COACH_MARK_SELECTOR, "-overlay");
exports.BC_COACH_MARK_MAIN = "".concat(exports.BC_COACH_MARK_SELECTOR, "-main");
exports.BC_COACH_MARK_NEXT = "".concat(exports.BC_COACH_MARK_SELECTOR, "-next");
exports.BC_COACH_MARK_PREV = "".concat(exports.BC_COACH_MARK_SELECTOR, "-prev");
exports.COACH_MARK_NEXT = "next";
exports.COACH_MARK_PREV = "prev";
exports.COACH_MARK_STEP = "step";
exports.BC_COACH_MARK_CLOSE = "".concat(exports.BC_COACH_MARK_SELECTOR, "-close");
exports.BC_COACH_MARK_ICON = "".concat(exports.BC_COACH_MARK_SELECTOR, "-icon");
exports.BC_COACH_MARK_QUANTITY_ITEMS = "".concat(exports.BC_COACH_MARK_SELECTOR, "-quantity-items");
exports.BC_COACH_MARK_NUMBER = "".concat(exports.BC_COACH_MARK_SELECTOR, "-number");
exports.BC_COACH_MARK_DATA_ATTRIBUTE = "dataCoachmark";
exports.BC_COACH_MARK_DATA_CONTROLLER = "dataController";
exports.BC_COACH_MARK_LINK = "".concat(exports.BC_COACH_MARK_SELECTOR, "-link");
exports.BC_COACH_MARK_BLOCK_SCROLL = "".concat(exports.BC_COACH_MARK_SELECTOR, "-scroll-block");
exports.BC_COACH_MARK_ANIMATION_IN = "fade-in-opacity ease-in-out 350ms forwards";
exports.BC_COACH_MARK_ANIMATION_OUT = 'ease-in-out 250ms forwards';
exports.BC_COACH_MARK_RIGHT = "right";
exports.BC_COACH_MARK_LEFT = "left";
exports.BC_COACH_MARK_TOP = "top";
exports.BC_COACH_MARK_BOTTOM = "bottom";
exports.BC_COACH_MARK_ARIA_LABEL = 'aria-label';
exports.BC_COACH_MARK_NUMBER_0 = 0;
exports.BC_COACH_MARK_NUMBER_1 = 1;
exports.BC_COACH_MARK_NUMBER_2 = 2;
exports.BC_COACH_MARK_NUMBER_6 = 6;
exports.BC_COACH_MARK_NUMBER_20 = 20;
exports.BC_COACH_MARK_NUMBER_16 = 16;
exports.BC_COACH_MARK_NUMBER_MIN_WIDTH = 280;
exports.BC_COACH_MARK_UNDERSTOOD_TEXT = 'Entendido';
exports.BC_COACH_MARK_NEXT_TEXT = 'Siguiente';
exports.BC_COACH_MARK_PREV_TEXT = 'Regresar';
exports.BC_COACH_MARK_CLOSE_TEXT = 'Cerrar';
exports.BC_COACH_MARK_STATUS = 'status';
exports.BC_COACH_MARK_STATUS_ACTIVE = 'active';
exports.BC_COACH_MARK_STATUS_ID = 'id';
exports.BC_COACH_MARK_ARROW_CLASS = "".concat(exports.BC_COACH_MARK_SELECTOR, "-arrow");
exports.BC_COACH_MARK_ARROW_SPACE = 16;
exports.BC_COACH_MARK_END_POSITION = 'end';
exports.BC_COACH_MARK_START_POSITION = 'start';
exports.BC_COACH_MARK_CENTER_POSITION = 'center';
exports.BC_COACH_MARK_WIDTH = 'width';
exports.BC_COACH_MARK_HEIGHT = 'height';
exports.BC_COACH_MARK_POSITION = 'position';
exports.BC_COACH_MARK_X = 'x';
exports.BC_COACH_MARK_Y = 'y';
exports.BC_COACH_MARK_Z_INDEX = '2001';
exports.BC_COACH_BUTTON_FOOTER = ':scope>section>section:nth-child(4)>button:first-child';
var CoachmarkStyle;
(function (CoachmarkStyle) {
    CoachmarkStyle["none"] = "none";
    CoachmarkStyle["flex"] = "flex";
    CoachmarkStyle["block"] = "block";
    CoachmarkStyle["contents"] = "contents";
})(CoachmarkStyle || (exports.CoachmarkStyle = CoachmarkStyle = {}));
var bcDisplay;
(function (bcDisplay) {
    bcDisplay["none"] = "bc-d-none";
    bcDisplay["flex"] = "bc-d-flex";
    bcDisplay["block"] = "bc-d-block";
    bcDisplay["contents"] = "contents";
})(bcDisplay || (exports.bcDisplay = bcDisplay = {}));
